import type { Brand } from "~utils/types/brand.ts";

export type ModulatorTypeId = Brand<number, "ModulatorTypeId">;

export enum EModulatorType {
  V2V5 = "V2V5",
  VX = "VX",
}
